import { StyleSheet, Text, View, Pressable, Linking } from 'react-native';
import React, { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useHelpStore } from './Store';

export default function HelpScreen() {


    const { phone, email, github, whatsappMessage, loadInfo, whatsappnumber } = useHelpStore();

    useEffect(() => {
        loadInfo();
    }, []);



    const navigation = useNavigation();

    const openPhone = () => {
        Linking.openURL(phone); // change number
    };

    const openEmail = () => {
        Linking.openURL(email); // change email
    };

    const openGithub = () => {
        Linking.openURL(github); // change link
    };

    const openWhatsApp = () => {

        Linking.openURL(`https://wa.me/${whatsappnumber}?text=${encodeURIComponent(whatsappMessage)}`);
    };

    return (
        <View style={styles.root}>

            {/* Back Button */}
            <Pressable onPress={() => navigation.goBack()}>
                <Text style={styles.back}>← Back</Text>
            </Pressable>

            <Text style={styles.title}>Help & Support</Text>

            {/* Phone */}
            <Pressable style={styles.button} onPress={openPhone}>
                <Text style={styles.buttonText}>📞 Call Us</Text>
            </Pressable>

            <Pressable style={styles.button} onPress={openWhatsApp}>
                <Text style={styles.buttonText}>💬 WhatsApp</Text>
            </Pressable>


            {/* Email */}
            <Pressable style={styles.button} onPress={openEmail}>
                <Text style={styles.buttonText}>📧 Email Support</Text>
            </Pressable>


            {/* GitHub */}
            <Pressable style={styles.button} onPress={openGithub}>
                <Text style={styles.buttonText}>💻 GitHub</Text>
            </Pressable>

        </View>
    );
}

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: "white",
        padding: 20,
        gap: 16,
    },
    back: {
        color: "#007AFF",
        fontSize: 16,
    },
    title: {
        fontSize: 24,
        fontWeight: "700",
        textAlign: "center",
        marginBottom: 20,
    },
    button: {
        backgroundColor: "#007AFF",
        padding: 14,
        borderRadius: 10,
        alignItems: "center",
    },
    buttonText: {
        color: "white",
        fontWeight: "600",
        fontSize: 16,
    },
});